module.exports = __webpack_public_path__ + "static/media/20_galeria_plantillas_combo_simple_rec_14.8b70aa26.png";